import { router } from 'expo-router';
import * as React from 'react';
import {
    BodyLargeRegular,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CheckCircleIcon,
    H6Regular,
    Icon,
    Private,
    Shadows,
    View,
    XStack,
    YStack,
} from 'smoothie';

const BillsSummary = ({ billsCount, billsAmount }) => {
    return (
        <YStack
            gap={16}
            padding={20}
            borderRadius="$5"
            borderWidth={1}
            borderColor="$gray200"
            flex={1}
            alignItems="center"
            backgroundColor="$white"
            {...Shadows.SMALL}
        >
            <BodyLargeRegular textAlign="left" width="100%">
                Your bills are on track this month
            </BodyLargeRegular>
            <XStack gap={20} justifyContent="center" width="100%" flex={1}>
                <YStack
                    flex={1}
                    borderRadius="$5"
                    overflow="hidden"
                    borderWidth={1}
                    borderColor="$gray200"
                    paddingHorizontal={20}
                    paddingVertical={12}
                    justifyContent="center"
                    alignItems="center"
                    gap={4}
                >
                    <BodySmallRegular>Bills</BodySmallRegular>
                    <XStack justifyContent="center" alignItems="center" gap={0}>
                        <Private>
                            <H6Regular
                                justifyContent="center"
                                alignItems="center"
                                paddingRight={4}
                            >
                                {billsCount}
                            </H6Regular>
                        </Private>
                        <Icon icon={CheckCircleIcon} color="$green1000" />
                    </XStack>
                </YStack>
                <YStack
                    flex={1}
                    borderRadius="$5"
                    overflow="hidden"
                    borderWidth={1}
                    borderColor="$gray200"
                    paddingHorizontal={20}
                    paddingVertical={12}
                    justifyContent="center"
                    alignItems="center"
                    gap={4}
                >
                    <BodySmallRegular>Monthly avg.</BodySmallRegular>
                    <XStack justifyContent="center" alignItems="center" gap={0}>
                        <Private>
                            <H6Regular
                                justifyContent="center"
                                alignItems="center"
                                paddingRight={4}
                            >
                                {billsAmount}
                            </H6Regular>
                        </Private>
                        <Icon icon={CheckCircleIcon} color="$green1000" />
                    </XStack>
                </YStack>
            </XStack>
            <View width="100%">
                <Button
                    text="View bills"
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    onPress={() => {
                        router.navigate('/bills/bills-overview');
                    }}
                />
            </View>
        </YStack>
    );
};

export default BillsSummary;
